import { render, staticRenderFns } from "./ProjectAgency.vue?vue&type=template&id=33a0a542&"
import script from "./ProjectAgency.vue?vue&type=script&lang=js&"
export * from "./ProjectAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports